import { useEffect, useState } from 'react'
import { indexBy } from '@cicero/data/utils'
import { useModel } from './useModel'
import { AttributeValueSchema } from '../AttributeValueSchema'
import { AttributeDoc, AttributeSchema } from '../AttributeSchema'
import { PageDoc } from '../PageSchema'

export const usePagesGroupedByAttribute = (pages: PageDoc[], attr: AttributeDoc|null) => {
  const AttributeValues = useModel(AttributeValueSchema)
  const [index, setIndex] = useState<{ [id: string]: PageDoc[] }>({})

  useEffect(() => {
    if (!attr || pages.length === 0) {
      setIndex({})
      return
    }

    const sub = AttributeValues.QUERY$(AttributeValueSchema.QUERIES.attrs(attr.id, pages.map(p => p.id)))
      .subscribe((values) => {
        const indexed = indexBy(values, 'page_id')
        const valueKey = AttributeSchema.TYPE_CONFIG[attr.type].valueKey
        const groups = pages.reduce((acc, page) => {
          const vals = indexed[page.id]
          const keys: string[] = []
          if (vals && vals.length) {
            vals.forEach(val => {
              const raw = val[valueKey]
              if (raw !== undefined) { keys.push(raw as any) }
            })
          } else {
            keys.push('_blank')
          }

          keys.forEach(key => {
            if (acc[key] === undefined) { acc[key] = [] }
            acc[key].push(page)
          })

          return acc
        }, {} as any)
        setIndex(groups)
      })

    return () => sub.unsubscribe()
  }, [pages, attr])

  return index
}
